// @flow strict

import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';

import * as styles from './category-image-banner.module.less';

type CategoryImageBannerProps = {
  src: { childImageSharp: { fluid: {} } },
  alt: string,
};

export const CategoryImageBanner = ({ src, alt }: CategoryImageBannerProps) => {
  const imagePath = src.childImageSharp.gatsbyImageData;
  return (
    <div className={styles.banner}>
      <GatsbyImage image={imagePath} alt={alt} />
    </div>
  );
};
